import React from 'react';
import { Container } from './styles';

const CardHeader = ({ children, additionalstyle }) => 
  <Container additionalstyle={additionalstyle}>{children}</Container>;

export default CardHeader;
